import type { RootState } from 'state';
import type { AffiliatesState } from '../slice';

function getAffiliates(state: RootState): AffiliatesState['value'] {
  const { value } = state.dataService.affiliates.affiliates;
  return value;
}

export default getAffiliates;
